module.exports = __webpack_public_path__ + "static/media/singleTests.a62ba756.svg";